import { Box, Divider, Typography } from '@mui/material';
import { getCoUsers } from 'entities/CoUser/api';
import { CoUserStatusEnum } from 'entities/CoUser/types';
import { useTranslation } from 'react-i18next';
import { FunctionComponent, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Loader } from 'shared/ui/Loader';
import { useCoUserDetailsInfoStore } from 'widgets/CoUsers/ui/CoUserDetailsInfo/model/state';
import { FilesHistory } from 'widgets/CoUsers/ui/CoUserDetailsInfo/ui/tabs/FilesHistory';
import { Logs } from 'widgets/CoUsers/ui/CoUserDetailsInfo/ui/tabs/Logs';
import { PersonalInfo } from 'widgets/CoUsers/ui/CoUserDetailsInfo/ui/tabs/PersonalInfo';
import { Permissions } from 'widgets/CoUsers/ui/CoUserDetailsInfo/ui/tabs/Permissions';
import { Tab } from './ui/Tab';

export const CoUserDetailsInfo: FunctionComponent = () => {
	const { t } = useTranslation();
	const { coUserId } = useParams<{ coUserId: string }>();
	const { activeTab, selectedCoUser, setSelectedCoUser, reset } = useCoUserDetailsInfoStore();

	useEffect(() => {
		return () => {
			reset();
		};
	}, []);

	const { isLoading } = useQuery({
		queryKey: ['co-users'],
		queryFn: () => getCoUsers(),
		onSuccess: (response) => {
			const found = response.data.find((u) => u._id === coUserId);
			if (found) setSelectedCoUser(found);
		},
	});

	if (isLoading && !selectedCoUser) return <Loader />;

	return (
		<>
			<Typography variant={'h4'} color={ColorPalette.astronaut}>
				{t('co_users.details_info')}
			</Typography>
			<Typography variant={'subtitle1'} color={ColorPalette.baliHai}>
				{selectedCoUser?.email}
			</Typography>

			<Divider color={ColorPalette.periwinkle} sx={{ margin: '44px 0' }} />
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					alignItems: 'center',
					gap: '20px',
					marginBottom: '44px',
				}}
			>
				<Tab label={t('co_users.tabs.tab_1')} tab={'personal-info'} />
				<Tab label={t('co_users.tabs.tab_2')} tab={'files-history'} />
				<Tab label={t('co_users.tabs.tab_3')} tab={'logs'} />
				{selectedCoUser?.status === CoUserStatusEnum.active && (
					<Tab label={t('co_users.tabs.tab_4')} tab={'permissions'} />
				)}
			</Box>
			{activeTab === 'personal-info' && <PersonalInfo coUser={selectedCoUser} />}
			{activeTab === 'files-history' && <FilesHistory coUser={selectedCoUser} />}
			{activeTab === 'logs' && <Logs coUser={selectedCoUser} />}
			{activeTab === 'permissions' && <Permissions coUser={selectedCoUser} />}
		</>
	);
};
